import truncate from 'lodash/truncate';
import get from 'lodash/get';
// @todo use own repository because we need some
// custom code (innerHTML with <span/> for styling)
import '@bnnvara/videojs-qualityselector';

const getSources = source =>
  source.map(({ name: format, src }) => ({ format, src }));
const getFormats = source =>
  source.map(({ name: code, name }) => ({ name, code }));

export default {
  mapPropStateToOptions: ({ source: mediaSources }) => {
    const defaultLabel = get(mediaSources, '[0].name');
    const truncatedDefaultLabel = truncate(defaultLabel, {
      length: 2,
      omission: '',
    });

    return {
      text: truncatedDefaultLabel,
      sources: getSources(mediaSources),
      formats: getFormats(mediaSources),
    };
  },
};
